import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@mui/material/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { useHistory, useParams } from "react-router-dom";
import {
  Button,
  Paper,
  Grid,
  TextField,
  MenuItem,
  Select,
  CircularProgress,
  InputLabel,
} from "@material-ui/core";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Autocomplete from "@mui/material/Autocomplete";
import {
  updateGrivance,
  getTicketCategories,
  getGrievance,
} from "../../actions/OffLineSupportActions";
let width = window.innerWidth;
let isMobile = width <= 500;

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "scroll",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: isMobile ? "400px" : "1200px",
    maxHeight: "600px",
    overflow: "scroll",
    position: "sticky",
  },
  head: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "2rem",
  },
  toolbar: {
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
 
    ...theme.mixins.toolbar,
  },
}));

type ModalProps = {
  open: boolean;
  setOpen: Function;
  loading: any;
  updateGrivance: any;
  setGrevianceId: any;
  grevianceId: any;
  getTicketCategories: any;
  ticketCategories: any;
  getGrievance: any;
  fetchGrivance: any;
  TicketData: any;
};

const CommentsModal2: React.FC<ModalProps> = ({
  open,
  setOpen,
  loading,
  updateGrivance,
  setGrevianceId,
  grevianceId,
  getTicketCategories,
  ticketCategories,
  getGrievance,
  fetchGrivance,
  TicketData,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const timer = useRef<any>(0);
  const { id } = useParams<{ id: string }>();
  const [status, setStatus] = React.useState<any>([]);
  const [remarks, setRemarks] = useState<any>("");
  const [category, setCategory] = useState<any>("");
  const [categoryName, setCategoryName] = useState<any>("");
  const [buttonType, setButtonType] = useState<boolean>(false);
  const [disposion, setDisposion] = useState<any>("");
  const [isEdit, setIsEdit] = useState<any>(false);

  const [assignToManager, setAssignToManager] = useState<any>("");
  const [assignTo, setAssignTo] = useState<any>("");

  const sendTo = `${assignTo},${assignToManager}`;
  const handleUpadte = async (e: any) => {
    const data: any = {
      status: status,
      remark: remarks,
      grievance_type: category,
      send_to: sendTo,
      center:TicketData?.cc_details?.id
    };
    await updateGrivance(data, grevianceId);
    history.push("/dashboard/os/grievance");
    setOpen(false);
    setStatus("");
    setRemarks("");
    setCategory("");
  };

  const handleClose = () => {
    setOpen(false);
    setButtonType(false);
    setStatus("");
    setRemarks("");
    setCategory("");
  };
  useEffect(() => {
    getTicketCategories();
  }, []);

  useEffect(() => {
    if (grevianceId !== null) {
      getGrievance(`${grevianceId}/`);
    }
  }, [grevianceId]);

  useEffect(() => {
    if (fetchGrivance) {
      const list = fetchGrivance;
      setIsEdit(true);
      setCategory(list?.grievance_type);
      setCategoryName(list?.grievance_type_name || "");
      setStatus(list?.status);
      setRemarks(list?.remark);
    }
  }, [fetchGrivance]);
  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (
      e.key === " " &&
      (!/[a-zA-Z0-9]/.test(e.currentTarget.value) ||
        !/[a-zA-Z0-9]/.test(e.currentTarget.value.slice(-1)))
    ) {
      e.preventDefault();
    }
  };
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <div className={classes.paper}>
          <div className={classes.toolbar}>
            <h3
              style={{
                textAlign: "center",
                fontWeight: "bold",
                color: "#333",
                padding: "10px 20px",
                borderBottom: "3px solid #007BFF",
                display: "inline-block",
                marginBottom: "20px",
                letterSpacing: "1px",
                textTransform: "uppercase",
                backgroundColor: "#f7f7f7",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
              Fill This Form
            </h3>
            <h6
              style={{
                color: "blue",
                marginTop: "10px",
                padding: "10px 20px",
                backgroundColor: "#f0f8ff",
                borderLeft: "4px solid #007BFF",
                borderRadius: "4px",
                fontStyle: "italic",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                fontSize: "14px",
                lineHeight: "1.5",
              }}
            >
              Note: Proper category will help in faster resolution of your
              tickets. If unsure please select category as Others
            </h6>
          </div>
          <Grid container spacing={1} style={{marginTop:"20px"}}>
            <Grid item xs={12} md={4} sm={4}>
              {/* <InputLabel
                htmlFor="status-select"
                style={{
                  fontWeight: "bold",
                  alignItems: "center",
                  marginTop: "-2px",
                }}
              >
                Category
              </InputLabel> */}
              <Autocomplete
                id="client_name"
                disablePortal
                onChange={(event, newValue) => {
                  if (newValue) {
                    let obj = JSON.parse(JSON.stringify(newValue, null, ""));
                    setCategory(obj?.id);
                  }
                }}
                options={ticketCategories.results || ""}
                inputValue={categoryName || ""}
                blurOnSelect
                freeSolo
                getOptionLabel={(option: any) => option?.title}
                onInputChange={(event, newInputValue) => {
                  setCategoryName(newInputValue);
                  clearTimeout(timer.current);
                  timer.current = setTimeout(() => {
                    getTicketCategories(newInputValue);
                  }, 1000);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="input"
                    label="Category"
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4} sm={4}>
              {/* <InputLabel
                htmlFor="status-select"
                style={{ fontWeight: "bold" }}
              >
                Select Status
              </InputLabel> */}
              <Select
                className="input"
                name="name"
                label="Remarks"
                value={status ? status : "none"}
                variant="outlined"
                style={{ width: "100%", margin: "0", height: "40px" }}
                onChange={(e) => setStatus(e.target.value)}
              >
                <MenuItem value="none">Select Status</MenuItem>
                <MenuItem value="In Progress">In Progress</MenuItem>
                <MenuItem value="To Do">To Do</MenuItem>
                <MenuItem value="Assigned to agent">Assigned to agent</MenuItem>
                <MenuItem value="Done">Done</MenuItem>
              </Select>
            </Grid>

            <Grid item xs={12} md={4} sm={4}>
                      <TextField
                        name="Assign To"
                        type="email"
                        value={assignTo}
                        className="input"
                        label="Assign To Email"
                        variant="outlined"
                        onChange={(e) => setAssignTo(e.target.value as string)}
                        style={{ width: "100%" }}
                      />
                    </Grid>
                    <Grid item xs={12} md={4} sm={4}>
                      <TextField
                        name="Assign To"
                        type="email"
                        value={assignToManager}
                        className="input"
                        label="Assign To Manager Email"
                        variant="outlined"
                        onChange={(e) =>
                          setAssignToManager(e.target.value as string)
                        }
                        style={{ width: "100%" }}
                      />
                    </Grid>
            <Grid xs={12}>
              <InputLabel
                htmlFor="status-select"
                style={{ fontWeight: "bold", alignItems: "center" }}
              >
                Remarks
              </InputLabel>
              <TextareaAutosize
                aria-label="minimum height"
                minRows={3}
                placeholder="Add Remarks.."
                value={remarks}
                required={status === "done"}
                onChange={(e: React.ChangeEvent<{ value: unknown }>) =>
                  setRemarks(e.target.value as string)
                }
                onKeyDown={handleKeyDown}
                style={{ width: "100%", height: "40px" }}
              />
              
            </Grid>
            <Grid xs={12} style={{ textAlign: "center" }}>
              <Button
                variant="contained"
                color="secondary"
                type="submit"
                style={{ width: "170px", marginTop: "10px" }}
                onClick={handleUpadte}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </div>
      </Fade>
    </Modal>
  );
};

const mapStateToProps = (state: any) => ({
  loading: state.OffLineSupporteReducer.loading,
  ticketCategories: state.OffLineSupporteReducer.ticketCategories,
  fetchGrivance: state.OffLineSupporteReducer.fetchGrivance,
});

export default connect(mapStateToProps, {
  updateGrivance,
  getTicketCategories,
  getGrievance,
})(CommentsModal2);